import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  open(event) {
    const url = event.params.url;
    if (!url) {
      return;
    }

    const indexUrl = window.location.href;

    window.history.pushState({ submissionModal: true }, '', url);

    const popstateHandler = () => {
      $.modal.close();
    };
    window.addEventListener('popstate', popstateHandler);

    $(document).one($.modal.AFTER_CLOSE, () => {
      window.removeEventListener('popstate', popstateHandler);
      window.history.replaceState(null, '', indexUrl);
    });
  }
}
